import React, { Component } from 'react';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import { sortData } from '../../common/globals';
import Bugsnag from '../../helpers/bugsnag';
import { getBackordersProducts } from '../../utils/utils';
import ProductSearchUI from '../commonComponents/ProductSearchUI';

class BackordersProducts extends Component {
  constructor(props) {
    super(props);

    this.state = {
      backordersProducts: [],
      productNo: '',
      productDescription: '',
      selectedProduct: '',
      active: null
    };
  }

  componentDidMount = async () => {
    const {
      online, notify
    } = this.props;
    if (!online) {
      notify({ type: 'error', message: 'You must have an internet connection. Please check your connection and try again.', time: 5 });
    } else {
      await this._onSearchBackorderProducts();
    }
  }

  _onProductSelect = (productNumber) => {
    const { selectedProduct, onSelectedProduct, onBackFromFilters } = this.props;
    if (!selectedProduct || selectedProduct.indexOf(productNumber) === -1) {
      onSelectedProduct(productNumber);
      return;
    }
    onBackFromFilters();
  }

  _onSearchBackorderProducts = async () => {
    const { setLoader, selectedAccount, selectedCaseType } = this.props;
    const searchData = {};
    const stringSearchData = {};
    if (selectedAccount.length) {
      searchData.accountName = selectedAccount;
    }
    if (selectedCaseType.length) {
      searchData.caseType = selectedCaseType;
    }
    if (this.state.productNo !== '') searchData.productNo = [this.state.productNo];
    if (this.state.productDescription !== '') stringSearchData.productDescription = this.state.productDescription;
    if (this.state.productNo.length > 3
      || this.state.productDescription.length > 3) {
      setLoader(true);
    }
    const backordersProductsResponse = await getBackordersProducts(searchData, stringSearchData);
    setLoader(false);
    const backordersProducts = sortData(backordersProductsResponse?.data.map((item) => ({
      ...item,
      ProductNo: Number(item.ProductNo)
    })), 'ProductNo');
    backordersProducts && this.setState({
      backordersProducts: backordersProducts
        .map((item) => ({ ...item, ProductNo: item.ProductNo.toString() }))
    });
  }

  async UNSAFE_componentWillMount() {
    try {
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const { backordersProducts, productNo, productDescription } = this.state;
    const { selectedProduct } = this.props;
    return (
      <ProductSearchUI
        setProductDescription={(value) => this
          .setState({ productDescription: value }, this._onSearchShipmentsProducts)}
        onProductSelect={this._onProductSelect}
        selectedProductsNumbers={selectedProduct}
        productNumber={productNo}
        setProductNumber={(value) => this
          .setState({ productNo: value }, this._onSearchBackorderProducts)}
        productDescription={productDescription}
        products={backordersProducts.map((product) => ({
          number: product.ProductNo,
          description: product.ProductDescription
        }))}
      />
    );
  }
}

export default withNotify(
  withLoader(
    BackordersProducts
  )
);
